import IExtension from "../../IExtension";
import '../simpleLightbox/simpleLightbox';
import {Naja} from "naja";
import {bindLightboxes, destroyLightboxes, LightboxBinding} from "./LightboxBindings";

export default class LightboxExtension implements IExtension {

    private bindings: LightboxBinding[] = [];

    public initialize(naja: Naja): void {
        naja.addEventListener('init', () => {
            this.bindings.push(...bindLightboxes($('body')));
        });
        naja.snippetHandler.addEventListener('beforeUpdate', (e) => {
            const snippet = e.detail.snippet;
            this.bindings = this.bindings.filter(binding => {
                const affected = binding.$items.toArray().some(item => snippet.contains(item));
                if (affected) {
                    destroyLightboxes([binding]);
                }
                return !affected;
            });
        });
        naja.snippetHandler.addEventListener('afterUpdate', () => {
            // A gallery can include items outside the replaced snippet.
            this.bindings.push(...bindLightboxes($('body')));
        });
    }
}
